import React from 'react';
import { ForgotPassword as AmplifyForgotPassword } from 'aws-amplify-react';
import { Route } from 'react-router-dom';

import PasswordReset from './PasswordReset';
import GotResetCode from './GotResetCode';
import SetNewPassword from './SetNewPassword';

export default class ForgotPassword extends AmplifyForgotPassword {
  showComponent() {
    return (
      <>
        <Route path="/forgot" exact>
          <PasswordReset />
        </Route>
        <Route
          path="/forgot/code"
          component={GotResetCode}
        />
        <Route
          path="/forgot/new/:email/:code"
          component={SetNewPassword}
        />
      </>
    );
  }
}

